export default __webpack_public_path__ + "static/media/daedarus.349e8cc7.png";